module.exports = __webpack_public_path__ + "static/img/label-04.e6b9451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/label-04.png
// module id = Y8rO
// module chunks = 31